import { exportTableToPdf } from '../exportTableToPdf';
import { getLessonsPdfCellStyle, LESSONS_BADGE_COLUMNS } from '../pdfCellStyles';
import {
    filterRowsByIds,
    formatPdfDateTime,
    formatPlainText,
    getVisibleColumnsFromOrder,
    stripHtmlToPlainText,
} from '../pdfTextUtils';

export const LESSONS_COLUMN_LABELS = {
    issue: 'Issue / Observation',
    action: 'Action Taken (This Project)',
    recomendation: 'Recommendation (Future)',
    tag: 'Tag',
    audience: 'Audience',
    loggedOn: 'Logged on',
    updatedOn: 'Updated on',
};

const COLUMN_WEIGHTS = {
    issue: 2.5,
    action: 2.2,
    recomendation: 2.2,
    tag: 1.1,
    audience: 1.2,
    loggedOn: 1.2,
    updatedOn: 1.2,
};

const getCellValue = (row, columnKey) => {
    switch (columnKey) {
        case 'issue':
            return stripHtmlToPlainText(row.issue || '');
        case 'action':
            return stripHtmlToPlainText(row.action || '') || 'Pending Input';
        case 'recomendation':
            return stripHtmlToPlainText(row.recomendation || '') || 'Pending Input';
        case 'tag':
            return formatPlainText(row.tag || 'Unspecified');
        case 'audience': {
            return formatPlainText(row.audience || '');
        }
        case 'loggedOn':
            return row.created ? formatPdfDateTime(row.created) : '';
        case 'updatedOn':
            return row.last_updated ? formatPdfDateTime(row.last_updated) : '';
        default:
            return '';
    }
};

export const exportLessonsToPdf = async ({
    rows,
    groupedSections = null,
    columnOrder,
    isColumnVisible,
    projectName,
    audienceOptions = [],
    selectedRowIds = null,
    filename = 'lessons_learnt.pdf',
}) => {
    const visibleColumns = getVisibleColumnsFromOrder(columnOrder, LESSONS_COLUMN_LABELS, isColumnVisible);
    const filteredRows = filterRowsByIds(rows, selectedRowIds);
    const context = { audienceOptions };

    const resolveAudienceLabel = value => {
        const opt = audienceOptions.find(o => o.value === value || o.label === value);
        return opt?.label || formatPlainText(value || 'Unspecified');
    };

    const sections = groupedSections?.length
        ? groupedSections.map(section => ({
              title: `${section.groupName} (${section.items?.length || 0})`,
              rows: filterRowsByIds(section.items, selectedRowIds),
              context,
          }))
        : null;

    await exportTableToPdf({
        title: 'Lessons Learnt',
        projectName,
        visibleColumns,
        rows: sections ? [] : filteredRows,
        groupedSections: sections,
        getCellValue: (row, columnKey) => {
            if (columnKey === 'audience') return resolveAudienceLabel(row.audience);
            return getCellValue(row, columnKey);
        },
        getCellStyle: (row, columnKey, ctx) => getLessonsPdfCellStyle(columnKey, row, ctx),
        columnWeights: COLUMN_WEIGHTS,
        badgeColumns: LESSONS_BADGE_COLUMNS,
        context,
        filename,
    });
};
